/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { Directionality } from "@angular/cdk/bidi";
import { ChangeDetectorRef, Component, ElementRef, Host, Optional, Renderer2, TemplateRef, ViewChild, ViewContainerRef } from "@angular/core";

import { slideMotion } from "ng-zorro-antd/core/animation";
import { NzNoAnimationDirective } from "ng-zorro-antd/core/no-animation";
import { NzSafeAny } from "ng-zorro-antd/core/types";
import { UiMenuService } from "@webapp/ui/menu/services/menu.service";
import { UiIsMenuInsideDropDownToken } from "@webapp/ui/menu/utils/menu.utils";
import { NzDropdownMenuComponent } from "ng-zorro-antd/dropdown";

@Component({
  selector: `ui-dropdown-menu`,
  exportAs: `uiDropdownMenu`,
  animations: [slideMotion],
  providers: [
    UiMenuService,
    /** menu is inside dropdown-menu component **/
    {
      provide: UiIsMenuInsideDropDownToken,
      useValue: true,
    },
  ],
  templateUrl: "./dropdown-menu.component.html",
})
export class UiDropdownMenuComponent extends NzDropdownMenuComponent {
  @ViewChild(TemplateRef, { static: true }) public templateRef!: TemplateRef<NzSafeAny>;

  public constructor(
    cdr: ChangeDetectorRef,
    elementRef: ElementRef,
    renderer: Renderer2,
    public viewContainerRef: ViewContainerRef,
    public uiMenuService: UiMenuService,
    @Optional() directionality: Directionality,
    @Host() @Optional() public noAnimation?: NzNoAnimationDirective
  ) {
    super(cdr, elementRef, renderer, viewContainerRef, uiMenuService, directionality, noAnimation);
  }
}
